import { useCallback, useState } from 'react';

export const useImageWithFallback = (...candidates: (string | undefined | null)[]) => {
  const cleaned = candidates.filter((c): c is string => !!c);
  const [index, setIndex] = useState(0);

  const onError = useCallback(() => {
    setIndex((i) => (i < cleaned.length - 1 ? i + 1 : i));
  }, [cleaned.length]);

  return { src: cleaned[index], onError };
};
